// src/Constants/links.js
const LINKS = {
  ETSY_SERUM: "https://www.etsy.com/listing/1900497969/topical-luteolin-serum-1-antioxidant-for",
  ETSY_LOTION: "https://www.etsy.com/listing/4444459342/topical-luteolin-lotion-lightweight",
};
export default LINKS;
